import React, { useState, useEffect } from 'react';
import PersonalDashboardMsl from '@components/templates/msl/dashboard/personalDashboardMsl';
import YearlyMetricsMsl from '@components/templates/msl/dashboard/yearlyMetricsMsl';
import QuarterDetailsMsl from '@components/templates/msl/dashboard/quarterlyDetailsMsl';
import DashboardAlerts from '@components/organisms/alertBar/dashboardAlerts';
import SpinnerLoader from '@components/atoms/SpinnerLoader';
import DateTimePicker from '@components/atoms/datePicker/dateTimePicker';
import {
  DashboardWrapper,
  CenteredSpinner,
  DashboardContainer,
  DashboardTitles,
  QuarterlyMatrixTitle,
} from '@pages/dashboard/dashboard.styles';
import { PAGES, DASHBOARD_PAGE_TITLE } from '@constants/commonConstants';

const screenName = PAGES.DASHBOARD;

const MslDashboard = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <DashboardWrapper>
      {loading ? (
        <CenteredSpinner>
          <SpinnerLoader color="#155CB4" />
        </CenteredSpinner>
      ) : null}
      <DashboardAlerts screenName={screenName} />
      <DashboardContainer>
        {!loading ? (
          <>
            <DashboardTitles>
              {DASHBOARD_PAGE_TITLE.MY_DASHBOARD}
              <DateTimePicker minDate={new Date('2025-07-01T01:00:00Z')} />
            </DashboardTitles>
            <PersonalDashboardMsl />
            <QuarterlyMatrixTitle>{DASHBOARD_PAGE_TITLE.QUARTERLY_METRICS}</QuarterlyMatrixTitle>
            <QuarterDetailsMsl />
            <QuarterlyMatrixTitle>{DASHBOARD_PAGE_TITLE.YEARLY_METRICS}</QuarterlyMatrixTitle>
            <YearlyMetricsMsl />
          </>
        ) : null}
      </DashboardContainer>
    </DashboardWrapper>
  );
};

export default MslDashboard;
